import { i18nDateToString } from 'modules/core/lib/dates'

import type ShiftConflict from 'modules/shift_management/store/internal/models/ShiftConflict'

const shiftConflictIsDate = (sc: ShiftConflict, date: moment.Moment): boolean => {
  return i18nDateToString(sc.localStartAt, 'backend') === i18nDateToString(date, 'backend')
}

export { shiftConflictIsDate }
